import React from 'react';
import { Link } from 'react-router-dom'; 
import { FiShield, FiLock, FiEye, FiDatabase, FiMail } from 'react-icons/fi';
import './Privacy.css';

const Privacy = () => {
  const sections = [
    {
      title: 'Information We Collect',
      icon: <FiDatabase />,
      content: 'We collect information you provide directly to us, such as when you create an account, make a purchase, sign up for newsletters, or contact customer service. This may include your name, email address, phone number, shipping address, payment information, and order history.'
    },
    {
      title: 'How We Use Your Information',
      icon: <FiEye />,
      content: 'We use the information we collect to process your orders, communicate with you about your purchases, send promotional emails (with your consent), improve our services, and personalize your shopping experience.'
    },
    {
      title: 'Information Sharing',
      icon: <FiShield />,
      content: 'We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website, conducting business, or servicing you, as long as they agree to keep your information confidential.'
    },
    {
      title: 'Data Security',
      icon: <FiLock />,
      content: 'We implement a variety of security measures to maintain the safety of your personal information. All sensitive information is transmitted via Secure Socket Layer (SSL) technology and encrypted in our database.'
    },
    {
      title: 'Cookies and Tracking',
      icon: <FiEye />,
      content: 'We use cookies to enhance your browsing experience, analyze site traffic, and understand where our visitors come from. You can choose to disable cookies through your browser settings, though this may affect site functionality.'
    },
    {
      title: 'Your Rights',
      icon: <FiMail />,
      content: 'You have the right to access, correct, or delete your personal information. You may also opt out of receiving marketing communications at any time by clicking the "unsubscribe" link in our emails or contacting us directly.'
    }
  ];

  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-description">
            Your privacy is important to us. Learn how we collect, use, and protect your information.
          </p>
          <p className="privacy-last-updated">Last Updated: February 15, 2026</p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="privacy-content">
        <div className="container">
          <div className="privacy-grid">
            <div className="privacy-main">
              <div className="privacy-intro">
                <h2>Our Commitment to Privacy</h2>
                <p>
                  At BASICK, we respect your privacy and are committed to protecting your personal information. 
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
                  you visit our website or make a purchase from us.
                </p>
                <p>
                  Please read this Privacy Policy carefully. By accessing or using our services, you acknowledge 
                  that you have read, understood, and agree to be bound by all the terms outlined in this policy.
                </p>
              </div>

              {sections.map((section, index) => (
                <div key={index} className="privacy-section">
                  <div className="section-header">
                    <span className="section-icon">{section.icon}</span>
                    <h2>{section.title}</h2>
                  </div>
                  <p>{section.content}</p>
                </div>
              ))}

              <div className="privacy-section">
                <h2>Children's Privacy</h2>
                <p>
                  Our services are not directed to individuals under the age of 13. We do not knowingly collect 
                  personal information from children. If you become aware that a child has provided us with 
                  personal information, please contact us immediately.
                </p>
              </div>

              <div className="privacy-section">
                <h2>Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time to reflect changes in our practices or 
                  for other operational, legal, or regulatory reasons. We will notify you of any material changes 
                  by posting the new Privacy Policy on this page with an updated effective date.
                </p>
              </div>
            </div>

            <div className="privacy-sidebar">
              <div className="sidebar-box">
                <h3>Contact Us</h3>
                <p>If you have questions about this Privacy Policy, please contact us:</p>
                <ul className="contact-list">
                  <li><FiMail /> privacy@basick.com</li>
                  <li>BASICK Privacy Department<br />200 Fifth Avenue<br />New York, NY 10010</li>
                </ul>
                <Link to="/contact" className="sidebar-btn">CONTACT US</Link>
              </div>

              <div className="sidebar-box">
                <h3>Quick Links</h3>
                <ul className="sidebar-links">
                  <li><Link to="/terms">Terms of Service</Link></li>
                  <li><Link to="/cookies">Cookie Policy</Link></li>
                  <li><Link to="/accessibility">Accessibility</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;